export default function Imperative() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr style={{ fontWeight: "bold" }}>
          <th>
            <em>infinitive</em>
          </th>
          <td> děla-ti</td>
          <td> prosi-ti</td>
          <td> nes-ti </td>
        </tr>
        <tr>
          <th> 2nd sg. ("Do!") </th>
          <td> děla-j </td>
          <td> prosi-j </td>
          <td> nes-i </td>
        </tr>
        <tr>
          <th> 2nd pl ("Do!") </th>
          <td> děla-jte </td>
          <td> prosi-jte </td>
          <td> nes-ite </td>
        </tr>
        <tr>
          <th> 1st ("Let's do!") </th>
          <td> děla-jmo </td>
          <td> prosi-jmo </td>
          <td> nes-imo </td>
        </tr>
      </tbody>
    </table>
  )
}
